module.exports = __webpack_public_path__ + "img/trash-white.5bce0668.svg";